import { State, Action } from '../../../types/video';

export const videoReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'setLoading':
      return {
        ...state,
        loading: action.loading,
      };
    case 'setClientUser':
      return {
        ...state,
        apiKey: action.api_key,
        userId: action.user_id,
        userName: action.user_name,
        userToken: action.user_token,
      };
    case 'setClient':
      return {
        ...state,
        client: action.client,
        feedback: { type: 'success', msg: 'Success! Connection created' },
      };

    case 'setStep':
      return {
        ...state,
        step: action.step,
      };
    case 'setCustomControls':
      return {
        ...state,
        customControls: action.customControls,
        feedback: { type: 'success', msg: 'Success! Custom controls created!' },
      };
    case 'setJoined':
      return {
        ...state,
        hasJoined: action.joined,
        feedback: {
          type: 'success',
          msg: 'Success! You have joined the call!',
        },
      };
    case 'setCall':
      return {
        ...state,
        call: action.call,
        feedback: { type: 'success', msg: 'Success! Call created' },
      };
    case 'setCallState':
      return {
        ...state,
        callState: action.callState,
      };
    case 'clearFeedback':
      return {
        ...state,
        feedback: undefined,
      };
    case 'setError':
      window.Sentry?.captureException(action.error);
      return {
        ...state,
        feedback: {
          type: 'error',
          msg: 'there was an error, please try again',
        },
      };
    default:
      throw new Error(`Invalid action: ${action.type}`);
  }
};
